import { Action } from '@ngrx/store';
import { OrderInformation, OrderLocation, PaymentInformation, PaymentMethodType } from '../../../../order/models';
import { ShippingMethodType } from '../../../../shopping-cart/models/shipping-method-type';

export enum ShoppingCartActionTypes {
  Checkout = '[ShoppingCart] Checkout Shopping Cart',
  CheckoutSuccess = '[ShoppingCart] Checkout Shopping Cart Success',
  CheckoutFail = '[ShoppingCart] Checkout Shopping Cart Fail',
  ClearOrder = '[ShoppingCart] Clear Order',
  SaveOrderInformation = '[ShoppingCart] Save Order Information',
  SaveOrderLocation = '[ShoppingCart] Save Order Location',
  SaveShippingMethod = '[ShoppingCart] Save Shipping Method',
  FetchPaymentInformation = '[ShoppingCart] Fetch Payment Information',
  FetchPaymentInformationSuccess = '[ShoppingCart] Fetch Payment Information Success',
  FetchPaymentInformationFail = '[ShoppingCart] Fetch Payment Information Fail',
  ClearPaymentInformation = '[ShoppingCart] Clear Payment Information'
}

export class Checkout implements Action {
  readonly type = ShoppingCartActionTypes.Checkout;
  constructor(public payload: { paymentMethod: PaymentMethodType }) { }
}

export class CheckoutSuccess implements Action {
  readonly type = ShoppingCartActionTypes.CheckoutSuccess;
}

export class CheckoutFail implements Action {
  readonly type = ShoppingCartActionTypes.CheckoutFail;
  constructor(public payload: any) { }
}

export class ClearOrder implements Action {
  readonly type = ShoppingCartActionTypes.ClearOrder;
}

export class SaveOrderInformation implements Action {
  readonly type = ShoppingCartActionTypes.SaveOrderInformation;
  constructor(public payload: OrderInformation) { }
}

export class SavrOrderLocation implements Action {
  readonly type = ShoppingCartActionTypes.SaveOrderLocation;
  constructor(public payload: OrderLocation) { }
}

export class SaveShippingMethod implements Action {
  readonly type = ShoppingCartActionTypes.SaveShippingMethod;
  // TODO: CHECK SHIPPING METHOD TYPE
  constructor(public payload: ShippingMethodType) { }
}

export class FetchPaymentInformation implements Action {
  readonly type = ShoppingCartActionTypes.FetchPaymentInformation;
  constructor(public payload: { zingOrderId: string }) { }
}

export class FetchPaymentInformationSuccess implements Action {
  readonly type = ShoppingCartActionTypes.FetchPaymentInformationSuccess;
  constructor(public payload: PaymentInformation) { }
}

export class FetchPaymentInformationFail implements Action {
  readonly type = ShoppingCartActionTypes.FetchPaymentInformationFail;
  constructor(public payload: any) { }
}

export class ClearPaymentInformation implements Action {
  readonly type = ShoppingCartActionTypes.ClearPaymentInformation;
}

export type ShoppingCartActions =
  Checkout
  | CheckoutSuccess
  | CheckoutFail
  | ClearOrder
  | SaveOrderInformation
  | SavrOrderLocation
  | SaveShippingMethod
  | FetchPaymentInformation
  | FetchPaymentInformationSuccess
  | FetchPaymentInformationFail
  | ClearPaymentInformation;
